<template>
  <div class="goods-order">
    <div class="order-cont">
      <div class="store-name van-hairline--bottom">
        <img :src="orderGoodsInfos.storeImg" alt="storeName" />
        <p>{{ orderGoodsInfos.storeName }}</p>
      </div>
      <div class="googds-list">
        <div class="list-wrap">
          <ul ref="googdList">
            <li v-for="(item, index) in orderGoodsInfos.goodsList" :key="index">
              <img :src="item.img" alt="item.name" />
            </li>
          </ul>
        </div>
        <span>共{{ orderGoodsInfos.goodsList.length }}件</span>
      </div>
      <div class="store-goods-info van-hairline--bottom">
        <van-tag round plain color="#37bc81">支持先行赔付</van-tag>
        <span class="change-time" v-if="changeTime">
          选择送达时间
          <van-icon name="arrow" size="16" color="#969799" />
        </span>
      </div>
    </div>
    <div class="coupon-box van-hairline--bottom">
      <van-coupon-cell
        :coupons="orderGoodsInfos.coupons"
        :chosen-coupon="orderGoodsInfos.chosenCoupon"
        @click="orderGoodsInfos.showCouponList = true"
      />
    </div>
    <div class="msg-box van-hairline--bottom">
      <van-field
        v-model="orderGoodsInfos.sendMsg"
        placeholder="用户留言备注"
        rows="1"
        autosize
        type="textarea"
        label="给卖家留言"
      />
    </div>
    <div class="order-detail">
      <div class="cell price">
        <span>商品金额</span>
        <em>{{ orderGoodsInfos.price | currency }}</em>
      </div>
      <div class="cell transp-price">
        <span>配送费</span>
        <em>{{ orderGoodsInfos.transpPrice | currency }}</em>
      </div>
      <div class="cell sales-price">
        <span>促销抵扣</span>
        <em>
          {{
          (orderGoodsInfos.salesPrice - orderGoodsInfos.couponsPrice)
          | currency
          }}
        </em>
      </div>
    </div>
    <!-- 优惠券列表 -->
    <van-popup
      v-model="orderGoodsInfos.showCouponList"
      round
      position="bottom"
      class="coupon-modal"
    >
      <van-coupon-list
        :coupons="orderGoodsInfos.coupons"
        :chosen-coupon="orderGoodsInfos.chosenCoupon"
        :disabled-coupons="orderGoodsInfos.disabledCoupons"
        @change="onChange"
        @exchange="onExchange"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "goodsOrder",
  props: {
    orderGoodsInfos: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      changeTime: false
    };
  },
  methods: {
    onChange(index) {
      this.orderGoodsInfos.showCouponList = false;
      this.orderGoodsInfos.chosenCoupon = index;
      if (index >= 0) {
        this.orderGoodsInfos.couponsPrice =
          this.orderGoodsInfos.coupons[index].value / 100;
      } else {
        this.orderGoodsInfos.couponsPrice = 0;
      }
    },
    onExchange() {
      // 兑换优惠券
    }
  },
  mounted() {
    this.boxWidth =
      document.querySelector(".googds-list li").clientWidth *
        this.orderGoodsInfos.goodsList.length +
      "px";
    this.$refs.googdList.style.width = this.boxWidth;
  }
};
</script>

<style scoped lang="scss">
.goods-order {
  padding: 10px;
  margin-bottom: 10px;
  background: #fff;
  border-radius: 6px;
  .order-cont {
    .store-name {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      align-content: stretch;
      padding-bottom: 6px;
      margin-bottom: 6px;
      img {
        width: 30px;
        height: 30px;
        border-radius: 50px;
        margin-right: 10px;
      }
      p {
        font-size: 16px;
      }
    }
    .googds-list {
      display: flex;
      justify-content: flex-start;
      .list-wrap {
        flex: 10;
        overflow: auto;
        ul {
          overflow: hidden;
          padding-bottom: 6px;
          li {
            float: left;
            padding-right: 10px;
          }
          img {
            width: 70px;
            height: 70px;
            border-radius: 6px;
          }
        }
      }
      span {
        flex: 2;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: stretch;
      }
    }
    .store-goods-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 10px;
      .change-time {
        font-size: 14px;
        color: #428eff;
        i {
          position: relative;
          top: 3px;
        }
      }
    }
  }
  // 优惠券块
  .coupon-box {
    .van-coupon-cell {
      padding-left: 0;
      padding-right: 0;
    }
  }
  // 留言块
  .msg-box {
    .van-cell {
      padding: 10px 0 10px;
    }
  }
  // 价格汇总
  .order-detail {
    padding: 10px 0 0;
    .cell {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 5px;
      font-size: 14px;
      span {
        color: #666;
      }
      em {
        font-weight: bold;
      }
      &.sales-price em {
        color: #ee0a24;
      }
    }
  }

  // 优惠券弹框
  .coupon-modal {
    padding-top: 10px;
  }
}
</style>
